var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1947_64913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75H12",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.75H8.625",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 14.625L6.75 13.5H4.5C3.90326 13.5 3.33097 13.2629 2.90901 12.841C2.48705 12.419 2.25 11.8467 2.25 11.25V5.25C2.25 4.65326 2.48705 4.08097 2.90901 3.65901C3.33097 3.23705 3.90326 3 4.5 3H13.5C14.0967 3 14.669 3.23705 15.091 3.65901C15.5129 4.08097 15.75 4.65326 15.75 5.25V8.25",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 16.5L16.0126 14.037C16.1667 13.8874 16.2892 13.7086 16.373 13.5109C16.4568 13.3133 16.5002 13.1008 16.5005 12.8861C16.5009 12.6714 16.4582 12.4588 16.3751 12.2609C16.2919 12.063 16.1699 11.8837 16.0163 11.7337C15.7029 11.4272 15.2822 11.2552 14.8439 11.2544C14.4055 11.2535 13.9842 11.4239 13.6696 11.7292L13.5016 11.8942L13.3343 11.7292C13.021 11.4229 12.6004 11.2511 12.1623 11.2502C11.7241 11.2494 11.3029 11.4196 10.9883 11.7247C10.8342 11.8742 10.7116 12.053 10.6277 12.2506C10.5439 12.4483 10.5004 12.6607 10.5 12.8754C10.4996 13.0901 10.5422 13.3027 10.6253 13.5006C10.7084 13.6986 10.8303 13.8779 10.9838 14.028L13.5001 16.5Z",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1947_64913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/Patients.92c3c8b57a95e716d7390eb73dfa3b85.svg";
export { ForwardRef as ReactComponent };